(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesController', TabDevicesController);

    TabDevicesController.$inject = ['$state', 'TabDevices', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabDevicesController ($state, TabDevices, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.currentState = "tab-devices";
        vm.currentStateFilter = "tab-devices-filter";
        vm.applyFilter = applyFilter;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        vm.deviceType = pagingParams.deviceType;
        var filter = localStorage.getItem(vm.currentStateFilter);

        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.deviceType = filter.deviceType;
            }
        }

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.searchText = pagingParams.search;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            // vm.transition(false);
        };

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                query: vm.searchText,
                sort: sort()
            };
            addFilter(body);
            TabDevices.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabDevices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter,
                search: vm.searchText
            }, {notify: notify, location: "replace"});
        }

        function applyFilter(deviceType) {
            var filter={};
            filter.deviceType = vm.deviceType = deviceType;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.deviceType.id !== -1)
                body.deviceTypeId = vm.deviceType.id;
        }

        vm.loadAll();
    }
})();
